import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CTAButtonProps {
  label: string;
  subline?: string;
  id?: string;
  variant?: 'primary' | 'outline';
}
export function CTAButton({
  label,
  subline,
  id,
  variant = 'primary'
}: CTAButtonProps) {
  const base = 'group flex w-full items-center justify-center gap-2 rounded-xl px-5 py-4 text-center font-display text-base sm:text-lg uppercase tracking-wide leading-tight transition-[transform,background-color,box-shadow] duration-200 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-300';
  const styles = variant === 'primary' ? 'bg-gold-500 text-navy-950 shadow-[0_10px_30px_-10px_rgba(212,163,44,0.8)] hover:bg-gold-400' : 'border-2 border-sky-400 bg-navy-800 text-sky-200 hover:bg-navy-700';
  return <div id={id} className="w-full" data-id="element-27" data-mp="38p2064pn9fqg">
      <a href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-28" data-mp="38q3imu8zp4i7">
        <span data-id="element-29" data-mp="199y70a05jr1m">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="19apq4lckbwb0" />
      </a>
      {subline && <p className="mt-3 text-center text-[11px] sm:text-xs font-medium uppercase tracking-wide text-sky-200/70" data-id="element-31" data-mp="1i89uw49mwaqd">
          {subline}
        </p>}
    </div>;
}